import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import HelpBlock from "./HelpBlock";

const Question = styled('div')`
  padding-bottom: 0.5em;
  
  & .question {
    padding-bottom: 1em;
  }
  & select {
    width: 50%;   
  }     
`;

const SelectBoxQuestion = ({items, selected, question, multi, onChange, placeholder, renderItem, error}) => (
  <Question>
    <div className="question">{question}</div>
    <select
      className="form-control"
      multiple={multi}
      onChange={e => onChange(e.currentTarget.value)}
    >
      <option>{placeholder}</option>
      {items.map(renderItem)}
    </select>
    {error && (<HelpBlock type="error"/>)}
  </Question>
);

SelectBoxQuestion.propTypes = {
  multi: PropTypes.bool,
  items: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  renderItem: PropTypes.func.isRequired,
  error: PropTypes.bool,
  placeholder: PropTypes.string.isRequired
};

export default SelectBoxQuestion;



// WEBPACK FOOTER //
// ./src/components/forms/SelectBoxQuestion.js